import * as React from 'react';
import { Route, Redirect } from 'react-router';
import { inject, observer } from 'mobx-react';
import { Loader } from '@bytebrand/fe-ui-core-autobahn/compat';
import AutobahnErrorBoundary from '../../autobahn/ErrorBoundary';
import styles from './PrivateRoute.styl';
const PrivateRoute = ({ path, component: Component, profileStore, ...rest }) => {
    const { areTermsFilled } = profileStore;
    const isAuthorized = rest['authStore'].isAuthorized;
    const isUserFetching = rest['authStore'].isAuthFetching;
    const isDealer = rest['authStore'].mainDealerId;
    const isDealerEmployee = rest['authStore'].isDealerEmployee;
    const isDealerMain = rest['authStore'].isDealerMain;
    const isAlternative = rest['authStore'].getAlternative();
    const isDealerPage = rest.dealerPage;
    const isUserPage = rest.userPage;
    // Forward our custom (non-routing) props to the rendered page. React-Router's
    // Route only injects {match,location,history}; without this, props like
    // `activeStep` (checkout) never reach the component.
    const passProps = { activeStep: rest.activeStep };
    // Every page gets a scoped error boundary with a recoverable fallback (BL-02).
    const renderPage = (element) => React.createElement(AutobahnErrorBoundary, null, element);
    const renderComponent = (props) => {
        if (isUserFetching && !isAuthorized) {
            return React.createElement(Loader, { className: styles.loader, size: 'large' });
        }
        if (isAuthorized) {
            if (isDealer && !areTermsFilled && path !== '/account/edit-dealer-profile') {
                return React.createElement(Redirect, { to: '/account/edit-dealer-profile' });
            }
            if (path === '/account/edit-dealer-profile' && isDealerEmployee) {
                return React.createElement(Redirect, { to: {
                        pathname: '/my-settings',
                        state: { from: props.location }
                    } });
            }
            if (!isAlternative && path.startsWith('/alternative')) { // redirect if not 'Alternativ-Car-Offers Portal' roles
                return React.createElement(Redirect, { to: '/search/' });
            }
            // Page only for regular users
            if (isUserPage && isDealerMain) {
                return React.createElement(Redirect, { to: {
                        pathname: '/search/',
                        state: { from: props.location }
                    } });
            }
            // Page is not for dealer but for authorized user
            // we can show it any authorized user
            if (!isDealerPage) {
                return renderPage(React.createElement(Component, { ...props, ...passProps }));
            }
            // Page only fof dealers we only can show to specific
            // users that have specific rights
            if (isDealerPage && isDealer) {
                return renderPage(React.createElement(Component, { ...props, ...passProps }));
            }
            // If page is only for dealers but user is not dealer
            // or do not have any rights to see it then just redirect
            // him to dealer sign up page
            if (isDealerPage && !isDealer) {
                return React.createElement(Redirect, { to: {
                        pathname: '/dealer/sign-up',
                        state: { from: props.location }
                    } });
            }
        }
        if (!isUserFetching && !isAuthorized) {
            return React.createElement(Redirect, { to: {
                    pathname: '/login/sign-in',
                    state: { from: props.location }
                } });
        }
        // default case if no correct statement
        return null;
    };
    return (React.createElement(Route, { ...rest, render: (props) => renderComponent(props) }));
};
export default inject('authStore', 'profileStore')(observer(PrivateRoute));
